import React, { useState, useRef } from 'react';
import { useAuth } from '../authentication/AuthContext';
import '../styles/HomePage.css';
import '../index.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// import '../i18n';
// import { useTranslation } from 'react-i18next';
import 'swiper/css/autoplay';
import { Navigation, Pagination, Autoplay } from 'swiper';
import { useFormSubmit } from '../services/useFormSubmit';
import { Link } from 'react-router-dom';

import 'swiper/css/effect-cards';

function HomePage() {
  // const { t, i18n } = useTranslation();

  // useEffect(() => {
  //   i18n.changeLanguage(navigator.language);
  // }, []);

  const { user } = useAuth();
  const [isPaused, setIsPaused] = useState(false);
  const [expandedFAQ, setExpandedFAQ] = useState([false, false, false, false, false]);
  const swiperRef = useRef(null);
  const { submitStatus, handleSubmit } = useFormSubmit();

  const toggleFAQ = (index) => {
    setExpandedFAQ(prev => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  return (
    <div className="home-page">
      <div className="top-hero hero hero-1">
        <div className="hero-grid-item">
          <h1>Validate your ideas in </h1>
          <h1>minutes, not weeks</h1>
          <h3>The future of focus groups is here.</h3>
          <h3>Get instant user feedback</h3>
          <h3>through the power of AI.</h3>
          
          <div className="button-container">
            <Link to="/use-cases" className="button secondary-button">Explore use cases</Link>
            {user ? (
              <Link to="/research" className="standout-button button">Start research</Link>
            ) : (
              <Link 
                to="/login" 
                state={{
                  from: '/research',
                  message: 'Please log in to access the app and start your research'
                }}
                className="standout-button button"
              >
                Try it for free! &rarr;
              </Link>
            )}
          </div>
        </div>
       
      </div>

      <div className='hero hero-1' >
        <h2>How does it work?</h2>
        <img src="/how-to-picture.jpg" alt="How to" className="how-to-image desktop-image" />
        <img src="/how-to-picture-mobile.jpg" alt="How to (mobile)" className="how-to-image mobile-image" />
      </div>

      <div className="hero hero-4" style={{backgroundColor: 'var(--secondary-color'}}>
        <div className="faq-grid">
          <div className="faq-header">
            <h2>Some questions you may have:</h2>
            {/* <div className="button-container">
              <Link to="/researchrequest" className="standout-button button">Request research</Link>
            </div> */}
          </div>
          <div className="faq-questions">
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(0)}>What are the limitations of AI-generated research?</h3>
              <div className={`faq-answer ${expandedFAQ[0] ? 'expanded' : ''}`}>
                <p>As a beta product, our AI tool has important limitations to understand. The responses are synthetic simulations, not real human feedback. While useful for quick testing and directional insights, some responses may contain inconsistencies. For critical business decisions, we recommend using our tool as an initial step before traditional research methods.</p>
              </div>
            </div>
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(1)}>How can I best use InstantFlows for my business?</h3>
              <div className={`faq-answer ${expandedFAQ[1] ? 'expanded' : ''}`}>
                <p>InstantFlows works best for rapid idea validation, concept testing, and early-stage research. It's ideal for testing multiple approaches quickly before investing in full development or traditional research. Many users find value in running several small tests to iterate on messaging, features, or designs.</p>
              </div>
            </div>
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(2)}>How do the AI virtual personas work?</h3>
              <div className={`faq-answer ${expandedFAQ[2] ? 'expanded' : ''}`}>
                <p>Our AI creates virtual personas based on demographic parameters you select. These are not real people but synthetic representations generated by our AI models. The quality of responses depends significantly on the context you provide and how clearly you frame your research questions.</p>
              </div>
            </div>
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(3)}>Why use InstantFlows instead of general AI tools?</h3>
              <div className={`faq-answer ${expandedFAQ[3] ? 'expanded' : ''}`}>
                <p>While general AI tools can provide some insights, InstantFlows is specifically designed for research with specialized prompts, demographic filtering, and analysis features. Our platform makes it easier to quickly test ideas, messages, and concepts without having to build your own AI research system from scratch.</p>
              </div>
            </div>
            <div className="faq-item">
              <h3 onClick={() => toggleFAQ(4)}>What kind of results will I receive?</h3>
              <div className={`faq-answer ${expandedFAQ[4] ? 'expanded' : ''}`}>
                <p>Our beta platform provides individual AI-generated responses, basic visualizations of response distributions, and demographic breakdowns. The insights are meant to help you identify potential patterns and opportunities for further exploration, not as definitive market research. We're continuously improving our analysis features based on user feedback.</p>
              </div>
            </div>
            </div>

        </div>
      </div>

        <div className="hero hero-3">
          <h2>Meet our personas</h2>
          <Swiper
            modules={[Pagination, Navigation, Autoplay]}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false
            }}
            speed={1500}
            initialSlide={2}
            spaceBetween={30}
            /* slidesPerGroup={1} */
            loop={true}
            pagination={{
              clickable: true,
            }}
            navigation={false}
            effect={"cards"}
            grabCursor={true}
            breakpoints={{
              720: { slidesPerView: 1 },
              800: { slidesPerView: 2 },
              1300: { slidesPerView: 3 },
              1600: { slidesPerView: 4 }
            }} 
          >
            {[
              {
                name: "Emily",
                title: "Marketing Manager",
                age: 34,
                salary: "€85,000/year",
                image: require('../components/personas/Emily.jpg'),
                backstory: "With 8 years of experience in digital marketing, Emily leads campaigns for major retail brands. She's passionate about data-driven decision making and building authentic brand voices.",
                interests: ["Digital Marketing", "Yoga", "Travel Photography"],
                challenges: "Balancing creative innovation with ROI metrics",
                goals: ["Increase brand engagement by 25%", "Develop sustainable marketing strategies"]
              },
              {
                name: "James",
                title: "Retired School Principal",
                age: 67,
                salary: "€32,000/year (pension)",
                image: require('../components/personas/James.jpg'),
                backstory: "James spent over 40 years in education, shaping the lives of thousands of students. Now retired, he volunteers at local literacy programs and enjoys spending time with his grandchildren.",
                interests: ["Gardening", "Volunteering", "Classical Music"],
                challenges: "Staying active and engaged in the community",
                goals: ["Mentor young educators", "Travel to historical sites"]
              },
              {
                name: "Sophie",
                title: "Freelance Graphic Designer",
                age: 23,
                salary: "€28,000/year",
                image: require('../components/personas/Sophie.jpg'),
                backstory: "Sophie is a recent art school graduate building her freelance portfolio. She works with startups and local businesses to create unique visual identities.",
                interests: ["Illustration", "Street Art", "Indie Music"],
                challenges: "Finding steady clients and managing finances",
                goals: ["Land a major brand project", "Host her first solo art show"]
              },
              {
                name: "Thomas",
                title: "Factory Shift Supervisor",
                age: 51,
                salary: "€48,000/year",
                image: require('../components/personas/Thomas.jpg'),
                backstory: "Thomas has worked in manufacturing for over 25 years, rising from line worker to supervisor. He values teamwork and safety on the job.",
                interests: ["Fishing", "DIY Projects", "Football"],
                challenges: "Adapting to new automation technologies",
                goals: ["Improve team safety record", "Save for early retirement"]
              },
              {
                name: "Sarah",
                title: "University Student",
                age: 19,
                salary: "€6,000/year (part-time)",
                image: require('../components/personas/Sarah.jpg'),
                backstory: "Sarah is studying environmental science and works part-time at a café. She's passionate about sustainability and hopes to work for an NGO.",
                interests: ["Environmental Activism", "Photography", "Travel"],
                challenges: "Balancing studies, work, and activism",
                goals: ["Win a research grant", "Organize a campus sustainability event"]
              },
              {
                name: "Daniel",
                title: "Paramedic",
                age: 41,
                salary: "€39,000/year",
                image: require('../components/personas/Daniel.jpg'),
                backstory: "Daniel has been a paramedic for 15 years, responding to emergencies in both urban and rural areas. He also teaches first aid courses.",
                interests: ["Mountain Biking", "Cooking", "First Aid Training"],
                challenges: "Managing stress and long shifts",
                goals: ["Train more community members in first aid", "Complete a marathon"]
              },
              {
                name: "Laura",
                title: "Entrepreneur (Bakery Owner)",
                age: 29,
                salary: "€54,000/year",
                image: require('../components/personas/Laura.jpg'),
                backstory: "Laura opened her own bakery after years as a pastry chef. She's focused on organic, locally sourced ingredients and community engagement.",
                interests: ["Baking", "Local Markets", "Yoga"],
                challenges: "Competing with large chains",
                goals: ["Open a second location", "Develop a line of gluten-free products"]
              },
              {
                name: "Abdel",
                title: "Taxi Driver",
                age: 58,
                salary: "€31,000/year",
                image: require('../components/personas/Abdel.jpg'),
                backstory: "Abdel immigrated 20 years ago and has been driving a taxi ever since. He enjoys meeting new people and sharing stories from his home country.",
                interests: ["Chess", "World News", "Family Gatherings"],
                challenges: "Navigating city changes and ride-share competition",
                goals: ["Buy a new car", "Visit his hometown with his children"]
              },
              {
                name: "Ryan",
                title: "High School Student",
                age: 16,
                salary: "€1,200/year (odd jobs)",
                image: require('../components/personas/Ryan.jpg'),
                backstory: "Ryan is a tech-savvy teenager who loves building robots and dreams of becoming an engineer. He does odd jobs for neighbors to save for college.",
                interests: ["Video Games", "Skateboarding", "Robotics Club"],
                challenges: "Balancing schoolwork and hobbies",
                goals: ["Win a robotics competition", "Get a scholarship for university"]
              }

            ].map((persona, idx) => (
              <SwiperSlide key={idx}>
                <div className="slide-content persona-slide-columns">
                  <div className='slide-content persona-slide-rows'>
                    
                    <div className="persona-details-column" style={{ flex: '1' }}>
                      <h3 className="name">{persona.name}</h3>
                      <i>{persona.title} </i>
                      <p>
                        {persona.age} years old<br/>
                        {persona.salary}
                      </p>
                    </div>
                    <div className="image-content">
                      <div className="card-image">
                        <img src={persona.image} alt={`${persona.name}'s profile`} className="img" />
                      </div>
                    </div>
                  </div>
                  <p className="persona-backstory" style={{ marginTop: '1rem' }}>{persona.backstory}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="hero hero-1">

          <h2>Interested in InstantFlows?</h2>
          <div className="textbox">
            <p>Sign up to stay updated on our progress!</p>
            <form 
              id="interest-form" 
              action="https://script.google.com/macros/s/AKfycbz3X8mRhapnoT9XdfOdhJjXJhO2Q5X0Sz-0FbLsjCK81WlB0rOHiTP1ib3I6acjfC5dmg/exec" 
              method="POST" 
              className="interest-form"
              onSubmit={(e) => handleSubmit(e, 'interest-form')}
            >
              <input type="text" name="Name" placeholder="Your Name" required />
              <input type="email" name="Email" placeholder="Your Email" required />
              
              <button type="submit" className="button">Keep Me Updated</button>
              {submitStatus.message && (
                <div className={submitStatus.isError ? 'error-message' : 'success-message'}>
                  {submitStatus.message}
                </div>
              )}
            </form>
          </div>
        </div>
    </div>
  );
}

export default HomePage;


